var _path, _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgZoomIn = function SvgZoomIn(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 13C21 15.4553 19.7359 17.6154 17.823 18.8648L18.9285 21.6286C19.1336 22.1414 18.8842 22.7234 18.3714 22.9285C17.8586 23.1336 17.2766 22.8842 17.0715 22.3714L16.0063 19.7083C15.3707 19.8981 14.6973 20 14 20C10.134 20 7 16.866 7 13C7 9.13401 10.134 6 14 6C17.866 6 21 9.13401 21 13ZM14 18C16.7614 18 19 15.7614 19 13C19 10.2386 16.7614 8 14 8C11.2386 8 9 10.2386 9 13C9 15.7614 11.2386 18 14 18Z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 12,
    width: 6,
    height: 2,
    rx: 0.5,
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 10,
    width: 2,
    height: 6,
    rx: 0.5,
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgZoomIn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "zoom-in.67d67995a36b8e47ee4c95695681ec4c.svg";